import React from "react";
import AddressCard from "./AddressStep/AddressCard";
import RegisteredAddressForm from "./AddressStep/RegisteredAddressForm";

class InvoiceAddressSelector extends React.Component {
  constructor(props) {
    super(props);

    // Ref for address form
    this.addressFormRef = React.createRef();

    // Eğer external state kontrolü varsa, o kullanılacak
    this.state = {
      sameAsDelivery:
        props.sameAsDelivery !== undefined ? props.sameAsDelivery : true,
      selectedAddressId: null, // Seçili adres ID'si
      isAddingNew: false, // Yeni adres ekleme modu
      editingAddressId: null, // Düzenlenen adresin ID'si
      formData: null, // Form verilerini sakla
    };

    // Bind methods
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.updateState = this.updateState.bind(this);
    this.handleAddressSelect = this.handleAddressSelect.bind(this);
    this.handleAddNew = this.handleAddNew.bind(this);
    this.handleCancelNew = this.handleCancelNew.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.handleSaveEdit = this.handleSaveEdit.bind(this);
    this.handleSaveNew = this.handleSaveNew.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.getEditingAddressData = this.getEditingAddressData.bind(this);
    this.getNewAddressData = this.getNewAddressData.bind(this);
    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    const { addresses, isRegistered, externalState } = this.props;

    // Eğer external state varsa onu kullan
    if (externalState) {
      this.setState({
        selectedAddressId: externalState.selectedAddressId,
        isAddingNew: externalState.isAddingNew,
        editingAddressId: externalState.editingAddressId,
        formData: externalState.formData,
      });
    } else if (
      !this.state.sameAsDelivery &&
      isRegistered &&
      addresses &&
      addresses.length > 0
    ) {
      // Eğer teslimat adresi ile aynı değilse ve kayıtlı kullanıcıysa, ilk aktif adresi seç
      const activeAddress =
        addresses.find(function (addr) {
          return addr.active;
        }) || addresses[0];
      this.setState({ selectedAddressId: activeAddress.id });
    }
  }

  componentDidUpdate(prevProps) {
    // Parent'tan gelen sameAsDelivery prop'u değiştiğinde internal state'i güncelle
    if (this.props.sameAsDelivery !== prevProps.sameAsDelivery) {
      this.setState({ sameAsDelivery: this.props.sameAsDelivery });
    }

    // External state değiştiğinde state'i güncelle
    if (
      this.props.externalState &&
      this.props.externalState !== prevProps.externalState
    ) {
      this.setState({
        selectedAddressId: this.props.externalState.selectedAddressId,
        isAddingNew: this.props.externalState.isAddingNew,
        editingAddressId: this.props.externalState.editingAddressId,
        formData: this.props.externalState.formData,
      });
    }
  }

  handleCheckboxChange(e) {
    const newValue = e.target.checked;
    this.setState({
      sameAsDelivery: newValue,
      isAddingNew: false,
      editingAddressId: null,
    });

    // Parent component'e bildir
    if (this.props.onSameAsDeliveryChange) {
      this.props.onSameAsDeliveryChange(newValue);
    }
  }

  updateState(newState) {
    this.setState(newState);

    // Parent component'e bildir (eğer onStateChange prop'u varsa)
    if (this.props.onStateChange) {
      this.props.onStateChange(newState);
    }
  }

  handleAddressSelect(address) {
    this.updateState({
      selectedAddressId: address.id,
      isAddingNew: false,
      editingAddressId: null,
    });
  }

  handleAddNew() {
    this.updateState({
      isAddingNew: true,
      selectedAddressId: "new",
      editingAddressId: null,
    });
  }

  handleCancelNew() {
    const { addresses } = this.props;
    const { selectedAddressId } = this.state;

    // Eğer hiç seçili adres yoksa ve adresler varsa, ilkini seç
    if (!selectedAddressId && addresses && addresses.length > 0) {
      const activeAddress =
        addresses.find(function (addr) {
          return addr.active;
        }) || addresses[0];
      this.updateState({
        isAddingNew: false,
        selectedAddressId: activeAddress.id,
        formData: null, // Formu temizle
      });
    } else {
      this.updateState({
        isAddingNew: false,
        formData: null, // Formu temizle
      });
    }
  }

  handleEdit(address) {
    this.updateState({
      editingAddressId: address.id,
      selectedAddressId: address.id,
      isAddingNew: false,
    });
  }

  handleCancelEdit() {
    this.updateState({
      editingAddressId: null,
      formData: null, // Formu temizle
    });
  }

  handleSaveEdit(addressId) {
    if (!this.addressFormRef.current) {
      alert("Form yüklenemedi. Lütfen sayfayı yenileyin.");
      return;
    }

    const addressData = this.addressFormRef.current.getData();
    if (!addressData) {
      return;
    }

    // Eğer parent'ta save fonksiyonu varsa onu çağır
    if (this.props.onSaveAddress) {
      this.props.onSaveAddress(addressId, addressData);
    }

    // Edit modundan çık
    this.updateState({
      editingAddressId: null,
      formData: null,
    });
  }

  handleSaveNew() {
    if (!this.addressFormRef.current) {
      alert("Form yüklenemedi. Lütfen sayfayı yenileyin.");
      return;
    }

    const addressData = this.addressFormRef.current.getData();
    if (!addressData) {
      return;
    }

    // Eğer parent'ta save fonksiyonu varsa onu çağır
    if (this.props.onSaveAddress) {
      this.props.onSaveAddress(null, addressData); // null = yeni adres
    }

    // Form'u sıfırla
    this.updateState({
      isAddingNew: false,
      selectedAddressId: null,
      formData: null,
    });
  }

  handleFormChange(formData) {
    // Form verileri değiştiğinde sakla
    this.updateState({
      formData: formData,
    });
  }

  getEditingAddressData() {
    const { editingAddressId, formData } = this.state;
    const { addresses } = this.props;

    // Eğer daha önce kaydedilmiş form verisi varsa onu kullan
    if (formData && editingAddressId) {
      return formData;
    }

    if (!editingAddressId || !addresses) return null;

    const address = addresses.find(function (addr) {
      return addr.id === editingAddressId;
    });

    if (!address) return null;

    return {
      first_name: address.first_name || "",
      last_name: address.last_name || "",
      city: address.city || "",
      town: address.town || "",
      phone: address.phone || "",
      address: address.address || "",
      postal_code: address.postal_code || "",
      address_name: address.address_name || "",
      saveAddress: true,
      // Fatura bilgileri
      invoice_type: address.invoice_type || "individual",
      company_name: address.company_name || "",
      tax_number: address.tax_number || "",
      tax_office: address.tax_office || "",
    };
  }

  getNewAddressData() {
    const { formData } = this.state;
    // Eğer daha önce kaydedilmiş form verisi varsa onu kullan
    return formData || null;
  }

  getData() {
    const { sameAsDelivery, selectedAddressId, isAddingNew, editingAddressId } =
      this.state;
    const { addresses } = this.props;

    // Eğer teslimat adresi ile aynıysa
    if (sameAsDelivery) {
      return { sameAsDelivery: true };
    }

    // Yeni adres ekleme modundaysa
    if (isAddingNew || editingAddressId) {
      const formData = this.addressFormRef.current
        ? this.addressFormRef.current.getData()
        : null;
      if (!formData) return null;

      return {
        sameAsDelivery: false,
        isNewAddress: isAddingNew,
        isEditMode: Boolean(editingAddressId),
        addressId: editingAddressId,
        ...formData,
      };
    }

    // Kayıtlı adres seçilmişse
    if (selectedAddressId && addresses) {
      const selectedAddress = addresses.find(function (addr) {
        return addr.id === selectedAddressId;
      });

      if (selectedAddress) {
        const invoiceType = selectedAddress.invoice_type || "individual";

        return {
          sameAsDelivery: false,
          selectedAddressId: selectedAddressId,
          invoice_first_name: selectedAddress.first_name,
          invoice_last_name: selectedAddress.last_name,
          invoice_type: invoiceType,
          invoice_title: invoiceType === "corporate" && selectedAddress.company_name
            ? selectedAddress.company_name
            : "",
          tax_office: selectedAddress.tax_office || "",
          tax_number: selectedAddress.tax_number || "",
          company_name: selectedAddress.company_name || "",
          address: selectedAddress.address,
          city: selectedAddress.city,
          town: selectedAddress.town,
          phone: selectedAddress.phone,
          email: selectedAddress.email || "",
        };
      }
    }

    return { sameAsDelivery: false };
  }

  render() {
    const { sameAsDelivery, selectedAddressId, isAddingNew, editingAddressId } =
      this.state;
    const { isRegistered, addresses } = this.props;

    return (
      <div>
        {/* Teslimat adresi ile aynı checkbox */}
        <div className="form-group" style={{ marginTop: "30px" }}>
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              className="custom-control-input"
              id="sameAsDeliveryInvoice"
              name="sameAsDelivery"
              checked={sameAsDelivery}
              onChange={this.handleCheckboxChange}
            />
            <label
              className="custom-control-label"
              htmlFor="sameAsDeliveryInvoice"
              style={styles.checkboxLabel}
            >
              Fatura adresim, teslimat adresim ile aynı olsun
            </label>
          </div>
        </div>

        {/* Teslimat adresi ile aynı değilse adres seçimi göster */}
        {!sameAsDelivery && isRegistered && (
          <div>
            <div style={styles.header}>
              <h6 style={styles.sectionTitle}>Fatura Adresi</h6>
            </div>

            <div style={styles.addressSection}>
              {/* Adres listesi - Adresler varsa */}
              {addresses && addresses.length > 0 && (
                <div style={styles.addressList}>
                  {addresses.map(
                    function (address) {
                      const isEditing = editingAddressId === address.id;

                      if (isEditing) {
                        // Düzenleme modunda - kart + form göster
                        return (
                          <div
                            key={address.id}
                            style={{
                              ...styles.editingCard,
                              ...(selectedAddressId === address.id
                                ? styles.editingCardSelected
                                : {}),
                            }}
                          >
                            <div
                              style={styles.editingCardHeader}
                              onClick={function () {
                                this.handleAddressSelect(address);
                              }.bind(this)}
                            >
                              <div style={styles.radioWrapper}>
                                <input
                                  type="radio"
                                  checked={selectedAddressId === address.id}
                                  onChange={function () {
                                    this.handleAddressSelect(address);
                                  }.bind(this)}
                                  style={styles.radio}
                                />
                              </div>
                              <div style={styles.editingContent}>
                                <h6 style={styles.editingText}>
                                  {address.address_name || "Adres"}
                                </h6>
                              </div>
                              <button
                                type="button"
                                onClick={function (e) {
                                  e.stopPropagation();
                                  this.handleCancelEdit();
                                }.bind(this)}
                                style={styles.cancelEditButton}
                              >
                                İptal
                              </button>
                            </div>

                            {/* Form - Düzenleme için */}
                            <div style={styles.editingFormContainer}>
                              <RegisteredAddressForm
                                key={"invoice-edit-" + address.id}
                                formPrefix="invoice_"
                                ref={this.addressFormRef}
                                initialData={this.getEditingAddressData()}
                                isEditMode={true}
                                onChange={this.handleFormChange}
                              />

                              {/* Düzenleme Butonları */}
                              <div style={styles.editingActions}>
                                <button
                                  type="button"
                                  onClick={function (e) {
                                    e.stopPropagation();
                                    if (!this.props.isSavingAddress) {
                                      this.handleCancelEdit();
                                    }
                                  }.bind(this)}
                                  style={{
                                    ...styles.cancelButton,
                                    ...(this.props.isSavingAddress
                                      ? styles.disabledButton
                                      : {}),
                                  }}
                                  disabled={this.props.isSavingAddress}
                                >
                                  İptal
                                </button>
                                <button
                                  type="button"
                                  onClick={function (e) {
                                    e.stopPropagation();
                                    if (!this.props.isSavingAddress) {
                                      this.handleSaveEdit(address.id);
                                    }
                                  }.bind(this)}
                                  style={{
                                    ...styles.saveButton,
                                    ...(this.props.isSavingAddress
                                      ? styles.disabledButton
                                      : {}),
                                  }}
                                  disabled={this.props.isSavingAddress}
                                >
                                  {this.props.isSavingAddress ? (
                                    <React.Fragment>
                                      <i
                                        className="fa fa-spinner fa-spin"
                                        style={{ marginRight: "8px" }}
                                      ></i>
                                      Kaydediliyor...
                                    </React.Fragment>
                                  ) : (
                                    "Kaydet"
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      }

                      return (
                        <AddressCard
                          key={address.id}
                          address={address}
                          isSelected={selectedAddressId === address.id}
                          onSelect={this.handleAddressSelect}
                          onEdit={this.handleEdit}
                          showEdit={true}
                        />
                      );
                    }.bind(this)
                  )}

                  {/* Yeni Adres Kartı */}
                  <div
                    style={{
                      ...styles.newAddressCard,
                      ...(selectedAddressId === "new"
                        ? styles.newAddressCardSelected
                        : {}),
                    }}
                  >
                    <div
                      style={styles.newAddressCardHeader}
                      onClick={this.handleAddNew}
                    >
                      <div style={styles.radioWrapper}>
                        <input
                          type="radio"
                          checked={selectedAddressId === "new"}
                          onChange={this.handleAddNew}
                          style={styles.radio}
                        />
                      </div>
                      <div style={styles.newAddressContent}>
                        <h6 style={styles.newAddressText}>Yeni Adres</h6>
                      </div>
                    </div>

                    {/* Form - Sadece seçiliyse göster */}
                    {selectedAddressId === "new" && isAddingNew && (
                      <div style={styles.newAddressFormContainer}>
                        <RegisteredAddressForm
                          key="invoice-new-address"
                          formPrefix="invoice_"
                          ref={this.addressFormRef}
                          initialData={this.getNewAddressData()}
                          onChange={this.handleFormChange}
                        />

                        {/* Yeni Adres Butonları */}
                        <div style={styles.editingActions}>
                          <button
                            type="button"
                            onClick={this.handleCancelNew}
                            style={{
                              ...styles.cancelButton,
                              ...(this.props.isSavingAddress
                                ? styles.disabledButton
                                : {}),
                            }}
                            disabled={this.props.isSavingAddress}
                          >
                            İptal
                          </button>
                          <button
                            type="button"
                            onClick={this.handleSaveNew}
                            style={{
                              ...styles.saveButton,
                              ...(this.props.isSavingAddress
                                ? styles.disabledButton
                                : {}),
                            }}
                            disabled={this.props.isSavingAddress}
                          >
                            {this.props.isSavingAddress ? (
                              <React.Fragment>
                                <i
                                  className="fa fa-spinner fa-spin"
                                  style={{ marginRight: "8px" }}
                                ></i>
                                Kaydediliyor...
                              </React.Fragment>
                            ) : (
                              "Kaydet"
                            )}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Hiç adres yoksa yeni adres formu göster */}
              {(!addresses || addresses.length === 0) && (
                <div>
                  <p style={styles.noAddressText}>
                    Kayıtlı adresiniz bulunmamaktadır.
                  </p>
                  <RegisteredAddressForm
                    key="invoice-no-address"
                    formPrefix="invoice_"
                    ref={this.addressFormRef}
                    initialData={this.getNewAddressData()}
                    onChange={this.handleFormChange}
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

const styles = {
  sectionTitle: {
    fontSize: "20px",
    fontWeight: "400",
    color: "#272727",
    margin: 0,
    lineHeight: "32px",
  },
  checkboxLabel: {
    fontSize: "15px",
    fontWeight: "500",
    color: "#34495e",
    cursor: "pointer",
  },
  addressSection: {
    marginTop: "20px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  addressList: {
    marginTop: "16px",
  },
  newAddressCard: {
    border: "1px solid rgb(229, 228, 233)",
    borderColor: "rgb(229, 228, 233)",
    borderRadius: "8px",
    marginBottom: "16px",
    transition: "all 0.2s ease",
    position: "relative",
    backgroundColor: "#fff",
    overflow: "hidden",
  },
  newAddressCardSelected: {
    backgroundColor: "rgb(247, 247, 249)",
    boxShadow: "rgb(132, 184, 23) 0px 0px 0px 1px",
    borderColor: "#84b817",
  },
  newAddressCardHeader: {
    padding: "18px 20px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  radioWrapper: {
    marginRight: "12px",
    display: "flex",
    alignItems: "flex-start",
    paddingTop: "4px",
  },
  radio: {
    width: "20px",
    height: "20px",
    cursor: "pointer",
    accentColor: "rgb(95, 141, 0)",
  },
  newAddressContent: {
    flex: 1,
  },
  newAddressText: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#272727",
    margin: 0,
  },
  newAddressFormContainer: {
    padding: "0 20px 20px 20px",
    borderTop: "1px solid #e6eaf2",
    marginTop: "0",
    paddingTop: "20px",
  },
  editingCard: {
    border: "2px solid #e6eaf2",
    borderRadius: "12px",
    marginBottom: "16px",
    transition: "all 0.2s ease",
    position: "relative",
    backgroundColor: "#fff",
    overflow: "hidden",
  },
  editingCardSelected: {
    borderColor: "#84b817",
    backgroundColor: "#f9fdf7",
    boxShadow: "0 2px 8px rgba(132, 184, 23, 0.12)",
  },
  editingCardHeader: {
    padding: "18px 20px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  editingContent: {
    flex: 1,
  },
  editingText: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#272727",
    margin: 0,
  },
  editingFormContainer: {
    padding: "0 20px 20px 20px",
    borderTop: "1px solid #e6eaf2",
    marginTop: "0",
    paddingTop: "20px",
  },
  cancelEditButton: {
    backgroundColor: "transparent",
    border: "none",
    color: "#dc3545",
    padding: "0",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
    marginLeft: "auto",
  },
  editingActions: {
    display: "flex",
    gap: "12px",
    marginTop: "24px",
    justifyContent: "flex-end",
  },
  cancelButton: {
    backgroundColor: "#fff",
    color: "#6c757d",
    border: "1px solid #dee2e6",
    padding: "10px 24px",
    borderRadius: "6px",
    fontSize: "15px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  saveButton: {
    backgroundColor: "#84b817",
    color: "#fff",
    border: "none",
    padding: "10px 32px",
    borderRadius: "6px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow: "0 2px 8px rgba(132, 184, 23, 0.2)",
  },
  disabledButton: {
    opacity: 0.6,
    cursor: "not-allowed",
  },
  noAddressText: {
    color: "#7f8c8d",
    fontSize: "14px",
    marginBottom: "16px",
    textAlign: "center",
    padding: "20px",
    backgroundColor: "#f8f9fa",
    borderRadius: "6px",
  },
};

export default InvoiceAddressSelector;



// WEBPACK FOOTER //
// ./src/components/InvoiceAddressSelector.js